module.exports = __webpack_public_path__ + "img/login-v2.854488d1.svg";